var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-input',{staticClass:"ametras-label",class:(_vm.$vuetify.theme.dark ? ' theme--dark' : ' theme--light'),attrs:{"dense":"","hide-details":""}},[_vm._v(" "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }